<template>
  <div class="sidenav-item">
    <div v-if="item.children">
      <button
        @click="toggle(item)"
        class="sidenav-item-link"
        :class="['level-' + level, { active: item.active }]"
      >
        <span>{{ item.title }}</span>
        <span class="icon" :class="{ rotate: item.expanded }">
          <svg
            class="bi bi-chevron-down"
            width="1em"
            height="1em"
            viewBox="0 0 16 16"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
            />
          </svg>
        </span>
      </button>
      <transition-expand>
        <div v-if="item.expanded" class="sidenav-item-children">
          <SidenavItem
            :level="level + 1"
            @active="active"
            @toggle="toggle"
            v-for="item in item.children"
            :key="item.name"
            :item="item"
          />
        </div>
      </transition-expand>
    </div>
    <template v-else>
    <template v-if="$store.state.navigation.site">
      <router-link
        @click.native="active(item.name)"
        class="sidenav-item-link"
        :class="'level-' + level"
        :to="{ name: item.name, params: item.clinicName ? {clinicName: item.clinicName ? item.clinicName : undefined} : undefined }"
      >
        {{ item.title }}
      </router-link>
    </template>
    <template v-else>
      <router-link
        @click.native="active(item.name)"
        class="sidenav-item-link"
        :class="'level-' + level"
        :to="{ name: item.name}"
      >
        {{ item.title }}
      </router-link>
    </template>
    </template>
  </div>
</template>

<script>
import TransitionExpand from '@app/components/uikit/animations/TransitionExpand';

export default {
  name: 'SidenavItem',
  components: { TransitionExpand },
  props: {
    item: Object,
    level: { default: 0 }
  },
  methods: {
    toggle(item) {
      this.$emit('toggle', item);
    },
    active(name) {
      this.$emit('active', name);
    }
  }
};
</script>

<style scoped>
.expand-enter-active,
.expand-leave-active {
  transition-property: opacity, height;
}
.expand-enter,
.expand-leave-to {
  opacity: 0;
}
.sidenav-item {
  width: 100%;
}
.sidenav-item-link {
  color: white;
  background-color: transparent;
  display: flex;
  width: 100%;
  transition: background-color 100ms;
}
.sidenav-item-link:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
.sidenav-item-link a {
  color: white;
  display: block;
  width: 100%;
}
.sidenav-item-link a:hover {
  text-decoration: none;
}
button.sidenav-item-link .icon {
  margin-left: auto;
}
button.sidenav-item-link .icon svg {
  transform: rotate(-90deg);
  transition: transform 200ms;
}
button.sidenav-item-link .icon.rotate svg {
  transform: rotate(0deg);
}
button.sidenav-item-link {
  outline: none;
  padding: 0;
  margin: 0;
  border: 0;
}
.sidenav-item .sidenav-item-link {
  font-weight: 300;
  font-size: 0.9rem;
}
.sidenav-item button.sidenav-item-link {
  padding: 0.5rem;
  padding-right: 1rem;
  font-weight: 300;
  font-size: 0.9rem;
}
.sidenav-item .sidenav-item-link {
  display: flex;
  padding: 0.5rem;
  padding-right: 1rem;
  text-decoration: none;
}
.sidenav-item button.sidenav-item-link.active,
.sidenav-item a.sidenav-item-link.router-link-exact-active {
  /* color: #5281c0; */
  background-color: rgba(255, 255, 255, 0.2);
}
.sidenav-item .sidenav-item-link.level-0 {
  text-transform: uppercase;
  padding-left: 1rem;
}
.sidenav-item .sidenav-item-link.level-1 {
  padding-left: 2rem;
}
.sidenav-item .sidenav-item-link.level-2 {
  padding-left: 3rem;
}
.sidenav-item .sidenav-item-link.level-3 {
  padding-left: 4rem;
}
</style>
